import { heroStats, heroStreamers } from "@/mocks/home";

export default function Hero() {
  const goRanking = () => {
    const el = document.getElementById("ranking");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const goReplay = () => {
    const el = document.getElementById("replay");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative overflow-hidden pt-28 md:pt-36 pb-12 md:pb-16">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-24 -left-20 h-72 w-72 rounded-full bg-primary-100 blur-3xl opacity-70" />
        <div className="absolute top-16 right-0 h-80 w-80 rounded-full bg-accent-100 blur-3xl opacity-60" />
      </div>

      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="max-w-3xl" data-reveal>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 text-xs md:text-sm font-medium text-secondary-900">
            <i className="ri-live-line text-primary-600" />
            51视频 · 主播内容导览
          </span>
          <h1 className="mt-5 text-3xl md:text-5xl font-bold leading-tight tracking-tight text-foreground-950">
            主播直播回放、网红福利视频与主播动态
            <span className="text-primary-600">一站集齐</span>
          </h1>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
            想追 51视频上的热门主播，却总错过直播？本站把往期直播回放、主题福利合辑和主播最新动态整理在同一个页面里。按分类筛选、按关键词搜索，就能快速找到想看的那一场，也能顺手发现还没关注过的新主播。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={goReplay}
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm md:text-base font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg" />
              浏览直播回放
            </button>
            <button
              type="button"
              onClick={goRanking}
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm md:text-base font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-trophy-line text-lg" />
              查看热门主播榜
            </button>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {heroStreamers.map((item) => (
            <article
              key={item.id}
              data-reveal
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={`主播 ${item.name} 的直播画面封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
                <span
                  className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium ${
                    item.live
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-50/90 text-foreground-800"
                  }`}
                >
                  <i
                    className={
                      item.live
                        ? "ri-record-circle-line animate-pulseSoft"
                        : "ri-history-line"
                    }
                  />
                  {item.live ? "直播中" : "回放"}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-black/45 px-2 py-1 text-[11px] text-white">
                  <i className="ri-eye-line mr-1" />
                  {item.viewers}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
                  <p className="text-sm md:text-base font-semibold text-white">
                    {item.name}
                  </p>
                  <p className="mt-0.5 text-[11px] md:text-xs text-white/80">
                    {item.tag}
                  </p>
                  <p className="mt-2 text-[11px] md:text-xs text-white/70 line-clamp-1">
                    {item.note}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div
          className="mt-8 md:mt-10 grid grid-cols-2 md:grid-cols-4 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200"
          data-reveal
        >
          {heroStats.map((stat) => (
            <div key={stat.label} className="bg-background-100 px-5 py-5 md:py-6">
              <p className="font-num text-xl md:text-3xl font-extrabold text-primary-600">
                {stat.value}
              </p>
              <p className="mt-1 text-xs md:text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}